import { Pipe, PipeTransform } from '@angular/core';

const fracty = require('fracty');

export function roundToPrecision(num: number, acc: number) {
  if (acc < 0) {
    return Math.round(num * acc) / acc;
  } else {
    return Math.round(num / acc) * acc;
  }
}

@Pipe({
  name: 'fracty',
  standalone: true,
})
export class FractyPipe implements PipeTransform {
  transform(value: number, ...args: number[]): string {
    const acc = args.length ? args[0] : 0.125;
    return fracty(roundToPrecision(value, acc));
  }
}
